import { Card, CardContent } from '@/components/ui/card';
import { Circle, Award, Star, Gem, Diamond, Check, Lock } from 'lucide-react';

var CIRCLE_ICONS = {
  circle: Circle,
  award: Award,
  star: Star,
  gem: Gem,
  diamond: Diamond,
};

var CIRCLE_BG = {
  bronze: 'bg-amber-700',
  silver: 'bg-slate-400',
  gold: 'bg-yellow-500',
  platinum: 'bg-slate-300',
  diamond: 'bg-cyan-300',
};

var CIRCLE_BORDER = {
  bronze: 'border-amber-700',
  silver: 'border-slate-400',
  gold: 'border-yellow-500',
  platinum: 'border-slate-300',
  diamond: 'border-cyan-300',
};

function PerksList(props) {
  var perks = props.perks;
  if (!perks) return null;
  var items = [];
  for (var j = 0; j < perks.length; j++) {
    items.push(
      <span key={j} className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">
        {perks[j]}
      </span>
    );
  }
  return <div className="flex flex-wrap gap-1.5">{items}</div>;
}

function TierCard(props) {
  var circle = props.circle;
  var isActive = props.isActive;
  var isUnlocked = props.isUnlocked;
  var Icon = CIRCLE_ICONS[circle.icon] || Circle;
  var bgClass = isUnlocked ? (CIRCLE_BG[circle.id] || 'bg-amber-700') : 'bg-slate-200';
  var borderClass = isActive ? ('border-2 ring-2 ring-offset-1 ' + (CIRCLE_BORDER[circle.id] || 'border-amber-700')) : '';
  var opacityClass = isUnlocked ? '' : 'opacity-50';

  return (
    <Card className={'glass-card transition-all ' + borderClass + ' ' + opacityClass} data-testid={'circle-tier-' + circle.id}>
      <CardContent className="p-4 flex items-start gap-4">
        <div className={'w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ' + bgClass}>
          {isUnlocked ? <Icon size={22} className="text-white" /> : <Lock size={18} className="text-slate-400" />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <p className="font-bold text-slate-900">{circle.name}</p>
            {isActive && (
              <span className={'text-[9px] font-bold px-2 py-0.5 rounded-full text-white ' + bgClass}>
                CURRENT
              </span>
            )}
            {isUnlocked && !isActive && <Check size={14} className="text-emerald-500" />}
          </div>
          <p className="text-xs text-slate-500 mb-2">{circle.min_credibility.toLocaleString()} credibility required</p>
          <PerksList perks={circle.perks} />
        </div>
      </CardContent>
    </Card>
  );
}

function CircleTiers(props) {
  var circles = props.circles;
  var currentCircle = props.currentCircle;
  var totalPoints = props.totalPoints;
  if (!circles) return null;

  var cards = [];
  for (var i = 0; i < circles.length; i++) {
    var c = circles[i];
    var active = currentCircle && currentCircle.id === c.id;
    var unlocked = totalPoints >= c.min_credibility;
    cards.push(<TierCard key={c.id} circle={c} isActive={active} isUnlocked={unlocked} />);
  }

  return <div className="space-y-3" data-testid="circle-tiers">{cards}</div>;
}

export default CircleTiers;
